import * as common from './common';
import './photos_favourites';
import './photoInfoContainer';
// import './projectSelector';
import './buying_process_popup';
import './selectProduct';
import './productDetails';
